import { useState } from 'react';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Deities.scss';

const deities = [
  { id: 1, name: 'Lord Shiva', img: 'https://servdharm.com/cdn/shop/articles/Untitled_design_b7f25b05-29a1-463b-922f-f1f526a196ca_800x.jpg?v=1682571145', description: 'Lord Shiva is known as the Destroyer within the Trimurti, the Hindu trinity that includes Brahma and Vishnu. He is revered for his role in destruction and transformation.' },
  { id: 2, name: 'Lord Vishnu', img: 'https://www.poojn.in/wp-content/uploads/2024/03/yash-deval-vishnuface.jpg', description: 'Lord Vishnu is the preserver and protector of the universe. He is known for his ten incarnations (Dashavatara) which he uses to restore cosmic order.' },
  { id: 3, name: 'Lord Brahma', img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLbaXW2SPteUtelCEBSKoKUJe253012a1k7g&s', description: 'Lord Brahma is the creator god in Hinduism. He is traditionally depicted with four heads and is considered the source of all knowledge.' },
  { id: 4, name: 'Goddess Lakshmi', img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLj313Fxm8t_kXm-ND6UQX5u6l50CDsV8GQqDT_UO9vmtaKJXB0wHIqHNTJ1VansR-AFo&usqp=CAU', description: 'Goddess Lakshmi is the goddess of wealth, fortune, and prosperity. She is often worshipped during Diwali and is believed to bring good luck.' },
  { id: 5, name: 'Goddess Saraswati', img: 'https://www.poojn.in/wp-content/uploads/2025/06/Poojns-Guide-to-Saraswati-Puja-2025-A-Complete-Ritual-Guide.jpeg.jpg', description: 'Goddess Saraswati is the goddess of wisdom, music, and learning. She is often depicted with a veena and a book.' },
  { id: 6, name: 'Goddess Durga', img: 'https://i0.wp.com/derekdodds.com/wp-content/uploads/2024/03/DALL%C2%B7E-2024-03-06-08.18.25-An-image-depicting-the-Hindu-goddess-Durga-a-symbol-of-strength-and-protection-riding-majestically-on-a-lion.-Durga-is-presented-with-multiple-arms.webp?resize=1024%2C1024&ssl=1', description: 'Goddess Durga symbolizes strength and protection. She is celebrated during Navratri and is known for slaying the demon Mahishasura.' },
  { id: 7, name: 'Lord Ganesha', img: 'https://www.poojn.in/wp-content/uploads/2025/02/Ganesh-Chaturthi-Celebration-Rituals-and-Traditions-Explained.jpeg.jpg', description: 'Lord Ganesha is the remover of obstacles and the god of beginnings. He is widely worshipped at the start of any venture or ritual.' },
  { id: 8, name: 'Lord Kartikeya', img: 'https://i0.wp.com/glorioushinduism.com/wp-content/uploads/2015/10/maxresdefault.jpg?fit=1024%2C576&ssl=1', description: 'Lord Kartikeya is the god of war and victory. He is also known as Murugan and is especially worshipped in South India.' },
  { id: 9, name: 'Lord Hanuman', img: 'https://cdn.shopify.com/s/files/1/0815/1000/7089/files/Hanuman-granted-immortality.jpg', description: 'Lord Hanuman is known for his unwavering devotion to Lord Rama. He symbolizes strength, devotion, and courage.' },
  { id: 10, name: 'Goddess Kali', img: 'https://static.wixstatic.com/media/98008d_28262dfd3f3b410580193983f52aeb85~mv2.webp/v1/fill/w_568,h_568,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/98008d_28262dfd3f3b410580193983f52aeb85~mv2.webp', description: 'Goddess Kali is a fierce form of Durga, representing destruction of evil and empowerment. She is worshipped for her strength and protection.' },
];

const Deities = () => {
  const [selectedDeity, setSelectedDeity] = useState(null);

  const openPopup = (deity) => {
    setSelectedDeity(deity);
  };

  const closePopup = () => {
    setSelectedDeity(null);
  };

  return (
    <div className="deities-container">
      <InnerNav />
      <div className="deities-content">
        <Zodiac />

        <div className="festival-header">
          <h4>Hindu Deities – Gods and Goddesses</h4>
        </div>

        <div className="festival-grid">
          {deities.map((deity) => (
            <div className="festival-card" key={deity.id} onClick={() => openPopup(deity)}>
              <img
              src={deity.img || 'https://static.wixstatic.com/media/e5bef8_5e96a9f9bb3949b7ad795137d65a900f~mv2.jpg/v1/fill/w_568,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e5bef8_5e96a9f9bb3949b7ad795137d65a900f~mv2.jpg'}
                alt={deity.name}
              />
              <p>{deity.name}</p>
            </div>
          ))}
        </div>

        {selectedDeity && (
          <div className="avatar-popup" onClick={closePopup}>
            <div className="avatar-popup-inner" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closePopup}>&times;</button>
              <h3>{selectedDeity.name}</h3>
              <img
              src={selectedDeity.img}
                alt={selectedDeity.name}
              />
              <p>{selectedDeity.description}</p>
            </div>
          </div>
        )}

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default Deities;
